/* eslint-disable */
export class ImageDropAndPaste {

  constructor(quill, options = {}) {
    this.quill = quill
    this.options = options
    this.handleDrop = this.handleDrop.bind(this)
    this.handlePaste = this.handlePaste.bind(this)
    this.quill.root.addEventListener('drop', this.handleDrop, false)
    this.quill.root.addEventListener('paste', this.handlePaste, false)
  }

  /* handle image drop event
  */
  handleDrop (e) {
    e.preventDefault()
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
      if (document.caretRangeFromPoint) {
        const selection = document.getSelection()
        const range = document.caretRangeFromPoint(e.clientX, e.clientY)
        if (selection && range) {
          selection.setBaseAndExtent(range.startContainer, range.startOffset, range.startContainer, range.startOffset)
        }
      }
      this.readFiles(e.dataTransfer.files, (dataUrl, type) => {
        if (typeof this.options.handler === 'function') {
          this.options.handler(dataUrl, type)
        } else {
          this.insert.call(this, dataUrl, type)
        }
      })
    }
  }

  /* handle image paste event
  */
  handlePaste (e) {
    if (e.clipboardData && e.clipboardData.items && e.clipboardData.items.length) {
      this.readFiles(e, e.clipboardData.items, (dataUrl, type, blob) => {
          setTimeout(() => {
            if (typeof this.options.handler === 'function') {
              this.options.handler(blob, this.quill)
            } else {
              this.insert(dataUrl, type)
            }
          }, 0)
      })
    }
  }

  /* read the files
  */
  readFiles (e, files, callback) {
    [].forEach.call(files, file => {
      var type = file.type
      if (!file.type.match(/^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i)) {
        return;
      } else {
        e.preventDefault()
      }
      const reader = new FileReader()
      const blob = file.getAsFile ? file.getAsFile() : file
      reader.onload = (e) => {
        callback(e.target.result, type, blob)
      }
      if (blob instanceof Blob) reader.readAsDataURL(blob)
    })
  }

  /* insert into the editor
  */
  insert (dataUrl, type) {
    const index = (this.quill.getSelection() || {}).index || this.quill.getLength()
    this.quill.insertEmbed(index, 'image', dataUrl, 'user')
  }

}


// WEBPACK FOOTER //
// ./src/plugins/quill-editor-custom/imageDropAndPaste.js